var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.69565C5 7.10232 7.10232 5 9.69565 5H90.3043C92.8977 5 95 7.10232 95 9.69565V90.3043C95 92.8977 92.8977 95 90.3043 95H9.69565C7.10232 95 5 92.8977 5 90.3043V9.69565ZM14.3913 14.3913V85.6087H85.6087V14.3913H14.3913Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 39C33.9853 39 36 41.1069 36 43.7059L36 74.2941C36 76.8931 33.9853 79 31.5 79C29.0147 79 27 76.8931 27 74.2941L27 43.7059C27 41.1069 29.0147 39 31.5 39Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 24C52.9853 24 55 26.1107 55 28.7143L55 74.2857C55 76.8893 52.9853 79 50.5 79C48.0147 79 46 76.8893 46 74.2857L46 28.7143C46 26.1107 48.0147 24 50.5 24Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5 50C70.9853 50 73 52.164 73 54.8333L73 74.1667C73 76.836 70.9853 79 68.5 79C66.0147 79 64 76.836 64 74.1667L64 54.8333C64 52.164 66.0147 50 68.5 50Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.17c904bf01ef61e95476d4d95aed35b1.svg";
export { ForwardRef as ReactComponent };